import LoadingButton from '@/components/button/loading-button';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/about')({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <div className="p-2">
      <h3>Welcome to About!</h3>
      <LoadingButton>Loading</LoadingButton>
    </div>
  );
}
